import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import {
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbTimepickerModule,
} from "@ng-bootstrap/ng-bootstrap";
import {
    ButtonSharedModule,
    CheckBoxSharedModule,
    IconSharedModule,
    ImgServiceDirectiveModule,
    InputSharedModule,
    SelectSharedModule,
    TooltipSharedModule,
} from "pf_styleguide";

import { DurationsModule } from "../../shared/module/durations/durations.module";
import { LoadingModule } from "../../shared/module/loading/loading.module";
import { MinutesToTextPipeModule } from "../../shared/module/pipe/minutes-to-text-pipe.module";
import { SelectDateModule } from "../../shared/module/select-date/select-date.module";
import { SelectTimeModule } from "../../shared/module/select-time/select-time.module";
import { VenuePipeModule } from "../venue-pipe.module";
import { EnquiryComponent } from "./enquiry.component";
import { VenueSidebarComponent } from "./venue-sidebar.component";

@NgModule({
    declarations: [VenueSidebarComponent, EnquiryComponent],
    imports: [
        CommonModule,
        RouterModule,
        VenuePipeModule,
        FormsModule,
        ReactiveFormsModule,
        NgbDropdownModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
        MinutesToTextPipeModule,
        LoadingModule,
        CheckBoxSharedModule,
        TooltipSharedModule,
        IconSharedModule,
        ButtonSharedModule,
        InputSharedModule,
        SelectDateModule,
        SelectTimeModule,
        DurationsModule,
        SelectSharedModule,
        ImgServiceDirectiveModule,
    ],
    exports: [VenueSidebarComponent],
})
export class VenueSidebarModule {}
